import React, { useState, useEffect, useRef } from "react";
import PWAInstallButton from "../../PWAInstallButton";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const mobileMenuRef = useRef(null);
    const toggleButtonRef = useRef(null);

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu function
    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        document.body.classList.remove('no-scroll');
    };

    // Toggle mobile menu function
    const toggleMobileMenu = () => {
        const newState = !isMobileMenuOpen;
        setIsMobileMenuOpen(newState);
        if (newState) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    };

    // Handle clicks outside mobile menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isMobileMenuOpen &&
                mobileMenuRef.current && 
                !mobileMenuRef.current.contains(event.target) &&
                toggleButtonRef.current && 
                !toggleButtonRef.current.contains(event.target)
            ) {
                closeMobileMenu();
            }
        };

        if (isMobileMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    // Handle escape key press
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && isMobileMenuOpen) {
                closeMobileMenu();
            }
        };

        document.addEventListener('keydown', handleEscapeKey);
        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isMobileMenuOpen]);

    // Close menu on window resize (when switching to desktop)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1200 && isMobileMenuOpen) {
                closeMobileMenu();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobileMenuOpen]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, []);

    return (
        <header 
            id="header" 
            className={`header sticky-top ${isScrolled ? 'scrolled' : ''}`}
        >
            <div className="container d-flex align-items-center justify-content-between position-relative">
                {/* Logo */}
                <div className="logo">
                    <a href="/" className="logo-link d-flex align-items-center">
                        <span className="logo-text fw-bold fs-4">PQHub</span>
                    </a>
                </div>

                {/* Desktop Navigation */}
                <nav 
                    ref={mobileMenuRef}
                    id="navmenu" 
                    className={`navmenu ${isMobileMenuOpen ? 'mobile-nav-active' : ''}`}
                >
                    <ul className="nav-list">
                        <li>
                            <a href="/" className="nav-link" onClick={closeMobileMenu}>Home</a>
                        </li>
                        <li>
                            <a href="/about" className="nav-link" onClick={closeMobileMenu}>About</a>
                        </li>
                        <li>
                            <a href="/questions" className="nav-link" onClick={closeMobileMenu}>Questions</a>
                        </li>
                        <li>
                            <a href="/packages" className="nav-link" onClick={closeMobileMenu}>Packages</a>
                        </li>
                        <li>
                            <a href="/contact" className="nav-link" onClick={closeMobileMenu}>Contacts</a>
                        </li>
                       
                        <li>
                            <a href="/verified-tutors" className="nav-link" onClick={closeMobileMenu}> Tutors</a>
                        </li>
                            {
                                localStorage.getItem('tutorAppId') && localStorage.getItem('email') ? (
                                    <><li><a href="/tutor/dashboard" className="nav-link">Dashboard</a></li></>
                                ) : (
                                    <><li><a href="/tutor/login" className="nav-link">Login</a></li></>
                                )
                            }

                        {/* 
                        <li>
                            <a href="/need-tutors" className="nav-link btn btn-outline-primary" onClick={closeMobileMenu}>Need Tutors?</a>
                        </li> */}
                     

                    </ul>

                    {/* Mobile Install Button - Inside Mobile Menu */}
                    <div className="mobile-install-btn d-xl-none mt-3 px-3">
                        <PWAInstallButton />
                    </div>

                    {/* Mobile Menu Close Button */}
                    <button 
                        className="mobile-nav-close d-xl-none"
                        onClick={closeMobileMenu}
                        aria-label="Close menu"
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </nav>

                {/* Desktop Action Buttons (including PWA Install) */}
                <div className="nav-actions d-none d-xl-flex align-items-center gap-2">
                    <PWAInstallButton />
                </div>

                {/* Mobile Menu Toggle Button */}
                <button 
                    ref={toggleButtonRef}
                    className="mobile-nav-toggle d-xl-none" 
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                    aria-expanded={isMobileMenuOpen}
                >
                    <i className={`bi ${isMobileMenuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            <div 
                className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} 
                onClick={closeMobileMenu}
            ></div>
        </header>
    );
};

export default Navbar;